import ToggleElementsViaRadioButtons from "../../../../toggle_elements_via_radio_buttons";

let elementsToggler = null;

const onLoad = () => {
  elementsToggler = new ToggleElementsViaRadioButtons(
    "#type-of-attachment-checkboxes",
    {
      feature_post: "#feature-post-row",
      catalogue: "#catalogue-row",
    }
  );
  elementsToggler.attach();
};

const onDestroy = () => {
  if (elementsToggler) {
    elementsToggler.detach();
    elementsToggler = null;
  }
};

document.addEventListener("turbolinks:before-cache", onDestroy);
document.addEventListener("turbolinks:before-render", onDestroy);
// document.addEventListener("turbolinks:load", onLoad);
$(document).ready(onLoad);
